<template>
    <div class="modal fade" id="details-contact-form" tabindex="-1" role="dialog" aria-labelledby="detailsContactForm" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content details-form-container">
                <div class="d-flex align-items-center pb-3">
                    <a :href="'/agents/'+marketer.slug">
                    <img class="details-agent-img" :src="marketer.profile_picture.url" :alt="marketer.name">
                    </a>
                    <div class="d-flex flex-column">
                    <a :href="'/agents/'+marketer.slug" class="normal">
                        <div class="details-agent-name text-capitalize">{{marketer.name.toLowerCase()}} {{marketer.chinese_name}}</div>
                    </a>
                    <div class="details-agent-post pt-2">{{marketer.job_title}}</div>
                    <div class="details-agent-post pt-1">{{ marketer.agent_level.split('_')[0] }} {{marketer.agent_number}}</div>
                    </div>
                </div>
                <form action="/enquiries" method="post" enctype="multipart/form-data">
                    <input type="text" name="enquiry[name]" placeholder="Name" required>
                    <input type="email" name="enquiry[email]" placeholder="Email" required>
                    <input type="tel" name="enquiry[contact_number]" placeholder="Phone number" required>
                    <textarea v-model="preMessage" rows="4" type="text" name="enquiry[message]" required></textarea>

                    <input type="hidden" name="enquiry[enquiry_type]" value="PROPERTY_ENQUIRY">
                    <input type="hidden" name="enquiry[find_listing_type]" :value="ltype">
                    <input type="hidden" name="enquiry[property_id]" :value="prop_id">
                    <input type="hidden" name="enquiry[comparison_id]" :value="comparison_id">
                    <input type="hidden" name="authenticity_token" :value="auth_token">
                    <input type="hidden" name="enquiry[recepient_id]" :value="marketer.id">

                    <re-captcha :recaptcha_sitekey="recaptcha_sitekey">
                    <div class="d-flex align-items-center justify-content-end">
                        <button type="button" data-dismiss="modal" class="messagebox-close-btn">Close</button>
                        <button type="submit" class="details-submit-btn">Book to View</button>
                    </div>
                    </re-captcha>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "prop-marketer",
    props: ['prop_id', 'prop_name', 'marketer','ltype','auth_token', 'recaptcha_sitekey'],
    data() {
      return {
        preMessage: 'Hi, ' + this.marketer.name + '. I would like to check the availability for '+ this.prop_name +'. Please call me back, Thank you!',
      }
    }
  };
</script>

<style scoped>
    .messagebox-close-btn {
        border: none;
        background: none;
        margin-right: 20px;
        padding-top: 15px;
        color: var(--p4redsurface1, #D80000);
        font-weight: 600;
    }
</style>